import { apiClient } from '../../api/client';
import { endpoints } from '../../api/endpoints';
import type { ProductInput } from '../../types';
import type { ProductsListResponse } from '../../types/api';
import type { Product } from '../../types';

export async function httpFetchProducts(): Promise<Product[]> {
  const response = await apiClient<ProductsListResponse | Product[]>(endpoints.products.list, {
    auth: false,
  });
  return Array.isArray(response) ? response : response.products;
}

export async function httpCreateProduct(input: ProductInput): Promise<Product> {
  return apiClient<Product>(endpoints.products.create, {
    method: 'POST',
    body: input,
  });
}

export async function httpUpdateProduct(id: string, input: ProductInput): Promise<Product> {
  return apiClient<Product>(endpoints.products.update(id), {
    method: 'PUT',
    body: input,
  });
}

export async function httpDeleteProduct(id: string): Promise<void> {
  await apiClient<void>(endpoints.products.delete(id), { method: 'DELETE' });
}

export async function httpUploadProductImages(id: string, files: File[]): Promise<Product> {
  const formData = new FormData();
  files.forEach((file) => formData.append('images', file));

  return apiClient<Product>(endpoints.products.uploadImages(id), {
    method: 'POST',
    body: formData,
  });
}

export async function httpDeleteProductImage(id: string, url: string): Promise<Product> {
  const query = new URLSearchParams({ url });
  return apiClient<Product>(`${endpoints.products.deleteImage(id)}?${query}`, {
    method: 'DELETE',
  });
}

export async function httpGetProduct(id: string): Promise<Product> {
  return apiClient<Product>(endpoints.products.detail(id), { auth: false });
}
